<template>
  <div class="property_item column flex flex-vertical-center" :class="[columnClass]">
    <p class="property_item--label">{{ label }}:</p>
    <p class="property_item--value">{{ value }}</p>
  </div>
</template>

<script>
export default {
  name: "PropertyModalItem",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String | Number,
      required: true,
    },
    columnClass: {
      type: String,
      default: 'is-4'
    }
  },
}
</script>

<style lang="scss" scoped>
.property_item {
  padding: 0;
  font-size: 0.825rem;
  line-height: 2;

  &--label {
    flex-basis: 160px;
    flex-shrink: 0;
    font-weight: bold;
  }

  &--value {

  }
}
</style>
